import { countries } from "src/constants/countries";
import { FieldType } from "src/models/filter";
import { Grouping } from "../types";

export const TRADES_GROUP_BY_OPTIONS: {
  name: string;
  value:
    | "client"
    | "time"
    | "instrument"
    | "timeframe"
    | "country"
    | "accountGroup";
}[] = [
  { name: "Client ID", value: "client" },
  { name: "Client Account Group", value: "accountGroup" },
  { name: "Time", value: "time" },
  { name: "Instrument", value: "instrument" },
  { name: "Timeframe", value: "timeframe" },
  { name: "Country", value: "country" },
];

export const DEPOSITS_GROUP_BY_OPTIONS: {
  name: string;
  value: "client" | "time" | "psp";
}[] = [
  { name: "Client ID", value: "client" },
  { name: "Time", value: "time" },
  { name: "PSP", value: "psp" },
];

export const WITHDRAWALS_GROUP_BY_OPTIONS: {
  name: string;
  value: "client" | "time" | "psp";
}[] = [
  { name: "Client ID", value: "client" },
  { name: "Time", value: "time" },
  { name: "PSP", value: "psp" },
];

export const defaultGrouping: Grouping = {
  groupBy: "client",
  groupFilter: [],
  timeGroup: "month",
};

export const TRADES_FILTER_CONFIG: {
  type: FieldType;
  label: string;
  id: string;
  options?: { name: string; value: string }[];
}[] = [
  {
    label: "From Date (UTC)",
    id: "fromDate",
    type: "date",
  },
  {
    label: "To Date (UTC)",
    id: "toDate",
    type: "date",
  },
  {
    label: "Asset",
    id: "asset",
    type: "text",
  },
  {
    label: "Country",
    id: "country",
    type: "dropdown",
    options: countries.map((country) => ({
      name: country.name,
      value: country.alpha_3_code,
    })),
  },
  {
    label: "Risk Flag",
    id: "riskFlag",
    type: "dropdown",
    options: [
      { name: "Normal", value: "0" },
      { name: "Risky", value: "risky" },
      { name: "Slow", value: "slow" },
    ],
  },
];

export const DEPOSITS_FILTER_CONFIG: {
  type: FieldType;
  label: string;
  id: string;
  options?: { name: string; value: string }[];
}[] = [
  {
    label: "From Date (UTC)",
    id: "fromDate",
    type: "date",
  },
  {
    label: "To Date (UTC)",
    id: "toDate",
    type: "date",
  },
  {
    label: "PSP",
    id: "psp",
    type: "text",
  },
  {
    label: "Currency Type",
    id: "currencyType",
    type: "text",
  },
  {
    label: "Local Currency",
    id: "localCurrency",
    type: "text",
  },
];

export const WITHDRAWALS_FILTER_CONFIG: {
  type: FieldType;
  label: string;
  id: string;
  options?: { name: string; value: string }[];
}[] = [
  {
    label: "From Date (UTC)",
    id: "fromDate",
    type: "date",
  },
  {
    label: "To Date (UTC)",
    id: "toDate",
    type: "date",
  },
  {
    label: "PSP",
    id: "psp",
    type: "text",
  },
  {
    label: "Currency Type",
    id: "currencyType",
    type: "text",
  },
  {
    label: "Local Currency",
    id: "localCurrency",
    type: "text",
  },
];
